import { JobApplicantSubBaseViewController } from '@/views/portal/hr/my_profile/JobApplicantSubBaseViewController';

export class JobApplicantLanguageSubViewController extends JobApplicantSubBaseViewController {
	constructor( options = {} ) {
		_.defaults( options, {} );

		super( options );
	}

	init( options ) {
		this.qualification_type_id = 40;
	}

	initOptions() {
		var $this = this;
		var args = {};
		this.api.getJobApplicantLanguageOptions( 'fluency', {
			onResult: function( result ) {
				$this.setSourceData( 'fluency_id', result.getResult(), true );
			}
		} );
		this.api.getJobApplicantLanguageOptions( 'competency', {
			onResult: function( result ) {
				$this.setSourceData( 'competency_id', result.getResult(), true );
			}
		} );

		var filter_data = {};
		filter_data.type_id = [this.qualification_type_id];
		args.filter_data = filter_data;
		args.filter_columns = {
			'id': true,
			'name': true
		};
		this.qualification_api.getQualification( args, true, {
			onResult: function( result ) {
				var res = result.getResult();
				var options = {};
				for ( var i in res ) {
					if ( !res.hasOwnProperty( i ) ) {
						continue;
					}
					var row = res[i];
					options[row.id] = $.i18n._( row.name );
				}
				$this.setSourceData( 'qualification_id', options, true );
			}
		} );
	}

	getJobApplicantLanguage( callback ) {
		var $this = this;
		var filter = {};
		filter.filter_data = {};
		filter.filter_data.id = this.model.id;
		this.api['getJobApplicantLanguage']( filter, {
			onResult: function( result ) {
				if ( result && result.isValid() ) {
					var result_data = result.getResult();
					if ( !result_data ) {
						result_data = [];
					}
					result_data = result_data[0];
					$this.model.set( result_data );
					if ( callback ) {
						callback();
					}
				} else {
					$this.showErrorAlert( result );
					ProgressBar.closeOverlay();
				}
			}
		} );
	}

	setCurrentEditRecordData() {
		super.setCurrentEditRecordData();
		var field_selector;
		var field_control;
		//Set current edit record data to all widgets
		for ( var key in this.model.attributes ) {
			if ( !this.model.has( key ) ) {
				continue;
			}
			switch ( key ) {
				default:
					if ( this.model.get( key ) === false ) {
						this.model.set( key, '' );
						if ( key === 'qualification_id' && this.enable_add_qualification ) {
							this.showAddQualificationContainer();
						}
					}
					field_selector = '.form-control[name="' + key + '"]';
					field_control = this.$( field_selector );
					if ( field_control && field_control[0] ) {
						this.$( field_selector ).val( this.model.get( key ) );
					}
					break;

			}
		}
	}
}
